import styled from 'styled-components';
import type { BlockProps } from '../../lib/card';
import { CardLayout } from '../../lib/card';
import { Counters, ShareButton } from '../components';
import { usePost } from '../Post';
import { usePostSettings } from '../utils';

interface CardActionsBlockProps extends BlockProps {
  withTopDivider?: boolean;
  withBottomDivider?: boolean;
  setIsDropDownOpen?: (value: boolean) => void;
  centered?: boolean;
}

export function CardActionsBlock({
  setIsDropDownOpen,
  withTopDivider = false,
  withBottomDivider = false,
  centered = false,
  ...forwardingProps
}: CardActionsBlockProps) {
  const { url } = usePost();
  const { showActions, textColor } = usePostSettings();

  if (!showActions) {
    return null;
  }

  return (
    <>
      {withTopDivider && (
        <CardLayout.Block>
          <Divider _color={textColor} />
        </CardLayout.Block>
      )}

      <CardLayoutBlock {...forwardingProps} _noShrink _isCentered={centered}>
        <Counters color={textColor} />

        <ShareButton
          url={url}
          color={textColor}
          setIsDropDownOpen={setIsDropDownOpen}
        />
      </CardLayoutBlock>

      {withBottomDivider && (
        <CardLayout.Block>
          <Divider _color={textColor} />
        </CardLayout.Block>
      )}
    </>
  );
}

const Divider = styled.div<{ _color: string }>`
  width: 100%;
  height: 1px;
  opacity: 0.1;
  background-color: ${({ _color }) => _color};
`;

const CardLayoutBlock = styled(CardLayout.Block)<{
  _isCentered: boolean;
}>`
  display: flex;
  width: 100%;
  gap: 16px;
  justify-content: ${({ _isCentered }) =>
    _isCentered ? 'center' : 'space-between'};
`;
